/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Tag({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M2.118 9.62a1 1 0 0 1 0-1.415l6.068-6.067a1 1 0 0 1 .715-.293l4.282.033a1 1 0 0 1 .992 1.008l-.033 4.203a1 1 0 0 1-.293.699l-6.074 6.074a1 1 0 0 1-1.415 0z" /><path fill="currentColor" d="M11.782 4.198a1.125 1.125 0 1 1-1.59 1.591 1.125 1.125 0 0 1 1.59-1.591" /></svg>;
}
;